import { trackingList } from "@/mocks/events";
import { Reveal, SectionHead } from "./ui";

export default function Tracking() {
  return (
    <section id="tracking" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHead
          index="02"
          en="Event Tracking"
          title="进行中的事件追踪"
          desc="吃瓜不是只看开头。我们为仍在发酵的热点建立进度档案，跟进每一步回应、每一份证据、每一个可能反转的节点。"
          extra={
            <span className="flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-xs font-semibold text-secondary-600 ring-1 ring-background-200">
              <i className="ri-refresh-line text-primary-500" aria-hidden="true"></i>
              共 {trackingList.length} 个事件正在跟进
            </span>
          }
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {trackingList.map((e, idx) => (
            <Reveal key={e.id} delay={idx * 110}>
              <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
                <div className="relative h-52 w-full overflow-hidden">
                  <img
                    src={e.image}
                    alt={`${e.title}事件追踪配图`}
                    title={`吃瓜前线 - ${e.category}事件追踪`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-foreground-950/80 px-2.5 py-1 text-xs font-semibold text-background-50 backdrop-blur-sm">
                    {e.category}
                  </span>
                  <span className="absolute right-3 top-3 flex items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {e.stage}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-[17px]">
                    {e.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-6 text-foreground-600">{e.lead}</p>

                  {/* progress */}
                  <div className="mt-4">
                    <div className="mb-1.5 flex items-center justify-between text-xs">
                      <span className="text-secondary-500">追踪进度</span>
                      <span className="font-semibold text-primary-600">{e.progress}%</span>
                    </div>
                    <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                        style={{ width: `${e.progress}%` }}
                      ></div>
                    </div>
                  </div>

                  {/* milestones */}
                  <div className="mt-4 border-t border-dashed border-background-200 pt-4">
                    <p className="mb-2.5 flex items-start gap-2 text-xs leading-5 text-primary-700">
                      <i className="ri-sparkling-line mt-0.5 shrink-0" aria-hidden="true"></i>
                      <span>{e.latest}</span>
                    </p>
                    <div className="flex flex-wrap items-center gap-1.5">
                      {e.milestone.map((m) => (
                        <span
                          key={m}
                          className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-700"
                        >
                          {m}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}